import { type PointsReward } from '@sg/graphql-schema';

import { useIsLoggedIn } from '../../context/AuthMachine';
import { useLoyaltyPointsRewardsQuery } from './GraphQL/LoyaltyPointsRewards.generated';

export const useLoyaltyPointsRewards = () => {
  const isLoggedIn = useIsLoggedIn();

  const [response, refetchPointsRewards] = useLoyaltyPointsRewardsQuery({
    pause: !isLoggedIn,
    requestPolicy: 'cache-and-network',
  });

  return {
    pointsRewards: response.data?.loyaltyProfile?.pointsRewards ?? emptyPointsRewards,
    isFetchingPointsRewards: response.fetching,
    refetchPointsRewards,
  };
};

const emptyPointsRewards: readonly PointsReward[] = [];
